export default __webpack_public_path__ + "static/media/aequalis6.420467cd.pdf";